import initialState from './initial.state';
import * as types from '../actions/types.action';
import {addBannerIndex, filterValidContent} from '../helpers/data.helper';
import {
  canUseWebP,
  reduceImageSize,
  scaleGirdSize,
  useWebp,
} from '../helpers/image.helper';
import {IMAGE_SIZE} from '../constants/constants';
import {sortBanners, sortTopBanners} from '../helpers/array.helper';

export default function cmsReducer(state = initialState.cms, action) {
  switch (action.type) {
    case types.GET_CMS_BANNERS_SUCCESS:
      let bannerIndex = 1;
      const lowerBanners = sortBanners(
        filterValidContent(scaleGirdSize(action.banners.lowerBanners))
      ).map(banner => {
        if (banner.length) {
          banner = addBannerIndex(banner);
        } else {
          banner.index = bannerIndex;
          bannerIndex++;
        }
        return banner;
      });
      const isWebPSupported = canUseWebP();
      const topBanners = sortTopBanners(
        filterValidContent(action.banners.topBanners, action.branch)
      ).map((banner, index) => {
        const mediaDesktopUrl = reduceImageSize(
          banner.mediaDesktopUrl,
          false,
          IMAGE_SIZE.BANNER
        );
        return {
          index,
          ...banner,
          ...{
            mediaDesktopUrl: isWebPSupported
              ? useWebp(mediaDesktopUrl)
              : mediaDesktopUrl,
          },
        };
      });
      return Object.assign({}, state, {
        banners: {
          topBanners,
          categoryAd: filterValidContent(action.banners.categoryAd),
          lowerBanners,
        },
      });

    case types.GET_CMS_VACANCIES_SUCCESS:
      return Object.assign({}, state, {
        vacancies: action.vacancies,
      });
    case types.GET_CMS_DEPARTMENTS_SUCCESS:
      return Object.assign({}, state, {
        departments: action.departments,
      });
    default:
      return state;
  }
}
